import { render, staticRenderFns } from "./ReportGeneralPane.vue?vue&type=template&id=c7b9bed8&"
import script from "./ReportGeneralPane.vue?vue&type=script&lang=ts&"
export * from "./ReportGeneralPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7b9bed8')) {
      api.createRecord('c7b9bed8', component.options)
    } else {
      api.reload('c7b9bed8', component.options)
    }
    module.hot.accept("./ReportGeneralPane.vue?vue&type=template&id=c7b9bed8&", function () {
      api.rerender('c7b9bed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/report/ReportGeneralPane.vue"
export default component.exports